﻿import $ from 'jquery';
import { ErrorPopover, IClearErrorOptions, IClearErrorWireup } from "./errorpopover";
import { FormValidation, IValidationHandler } from "./formvalidation"

export class CheckboxValidationHandler implements IValidationHandler {
  handle($error: JQuery): boolean {
    var $checkboxField = $error.closest('.input-checkbox-field');
    var isCheckbox = $checkboxField.length > 0;
    if (!isCheckbox)
      return false;

    if ($checkboxField.data('error-handled') == true)
      return true;

    var errorMessage = $error.html();
    $checkboxField.data('error-handled', true);
    $checkboxField.addClass(FormValidation.validationClass);

    $error.remove();

    var $input = $checkboxField.find('[type="checkbox"]');
    var id = $input.attr('id');

    new ErrorPopover().append($input, id, errorMessage, null, 
      {
        onErrorPopoverDisabled: () => this.onErrorPopoverDisabled($checkboxField)
      } as IClearErrorOptions);

    return true;
  }

  private onErrorPopoverDisabled($field: JQuery): void {
    $field.removeClass(FormValidation.validationClass);
  }
}
